import { communicationsApi } from '@app/services'

import { FetchRawEmailContentResponse } from './types'

export const fetchRawEmailContent = async (
  conversationId: number,
  messageId: number | null,
  signal: AbortSignal
) => {
  const { data } = await communicationsApi.get<FetchRawEmailContentResponse>(
    `conversation/${conversationId}/messages/${messageId}/rawemailcontent`,
    {
      params: {
        conversationId,
        messageId,
      },
      signal,
    }
  )
  return data
}
